<ul class="list">
  @for (item of list; track item) {
    <li class="list-item">
      @if (item.link) {
        <a href="{{ item.link }}">{{ item.label }}</a>
      }
      @if (!item.link) {
        <span>{{ item.label }}</span>
      }
    </li>
  }
  @if (cookiesInited) {
    <li class="list-item">
      <button onclick="CookieFirst.openPanel();" i18n>cookies</button>
    </li>
  }
  @if (!copyrightLong) {
    <li class="list-item--copyright">
      <span>© {{ dateNow | date: "Y" }}</span>
    </li>
  }
</ul>

@if (copyrightLong) {
  <p class="copyrightLong">
    © {{ dateNow | date: "Y" }} {{ siteTitle }}{{ copyrightLong }}
  </p>
}
